import { ModuleFolder, moduleFolders } from './module1-data';

export type PlaylistModule = {
  id: string;
  name: string;
  viewPath: string;
  folders: ModuleFolder[];
};

export const playlistModules: PlaylistModule[] = [
  {
    id: 'module1',
    name: 'Module 1',
    viewPath: '/module1/view',
    folders: moduleFolders,
  },
  ...Array.from({ length: 6 }, (_, index) => ({
    id: `module${index + 2}`,
    name: `Module ${index + 2}`,
    viewPath: `/module${index + 2}/view`,
    folders: [],
  })),
];
